const hashCode = (s: string) => s.split('').reduce((a, b) => ((a << 5) - a + b.charCodeAt(0)) | 0, 0)

export const hashName = (name: string, value: string) => `${name}-${hashCode(value)}`
